export function Divider() {
  return (
    <div className="flex items-center my-6">
      <div className="flex-1 h-px bg-ll-border" />
      <span className="px-4 text-xs uppercase tracking-widest font-mono text-ll-muted">OR</span>
      <div className="flex-1 h-px bg-ll-border" />
    </div>
  );
}
